import React, { useEffect, useState } from "react";
import { utilService } from "../../../../services";
import sanitizeHtml from "sanitize-html";
import { EMSAudioService } from "./EMSAudioComponent.service";
import { dataTransferService } from "../../../../services/dataTransferService";
import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";
import {
  MediaCapture,
  MediaFile,
  CaptureAudioOptions,
} from "@ionic-native/media-capture";

// import { CameraResultType, Capacitor } from "@capacitor/core";
import { Capacitor } from "@capacitor/core";
import { File as ionicFile } from "@ionic-native/file";
declare const Recorder: any;

interface AudioComponentProps {
  onCompleteMedia: () => void;
  selectedDoctorData: object;
  isStatusBoard?: boolean;
  smsThread?: any;
}

const EMSAudioComponent: React.FC<AudioComponentProps> = (props) => {
  //   const [input, setInput]: any = useState();
  const [gumStream, setGumStream]: any = useState();
  const [rec, setRec]: any = useState();
  const [status, setStatus]: any = useState();
  const [isWeb, setIsWeb]: any = useState(false);

  useEffect(() => {
    if (utilService.isWeb()) {
      setIsWeb(true);
    }
  }, []);

  useEffect(() => {
    if (rec) {
      webRecordingStarted();
    }
  }, [rec]);

  useEffect(() => {
    let sub = dataTransferService.getEMSAudioMediaAction.subscribe(
      (data: any) => {
        if (data === true) {
          startRecord();
        } else {
          stopRecord();
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  });

  const startRecord = () => {
    if (utilService.isWeb()) {
      webStartRecord();
    } else {
      nativeStartRecord();
    }
  };

  const stopRecord = () => {
    if (utilService.isWeb()) {
      webStopRecord();
    } else {
    }
  };

  const webStartRecord = () => {
    var constraints = {
      audio: true,
      video: false,
    };
    // const self = this;
    // Disable the record button until we get a success or fail from getUserMedia() /

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        console.log(
          "getUserMedia() success, stream created, initializing Recorder.js ..."
        );
        // assign to gumStream for later use /
        setGumStream(stream);
        // use the stream /
        var AudioContext = (window as any).AudioContext;
        var audioContext = new AudioContext();
        // setInput(audioContext.createMediaStreamSource(stream));
        const input = audioContext.createMediaStreamSource(stream);
        // Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size /
        const rec = new Recorder(input, {
          numChannels: 1,
        });
        setRec(rec);
      })
      .catch(function (err) {
        //enable the record button if getUserMedia() fails
      });
  };

  const webRecordingStarted = () => {
    rec.record();
    setStatus("Recording started...");
  };

  const webStopRecord = () => {
    if (rec) {
      rec.stop();
      gumStream.getAudioTracks()[0].stop();
      rec.exportWAV(createDownloadLink);
    }
  };

  const createDownloadLink = (blob: Blob) => {
    const fileName =
      "AUD_" +
      new Date().toISOString().slice(0, 10) +
      "_" +
      new Date().toLocaleTimeString() +
      ".mp3";
    const fileData = new File([blob], fileName, {
      lastModified: new Date().getTime(),
      type: blob.type,
    });
    const URL = (window as any).URL || (window as any).webkitURL;
    var url = URL.createObjectURL(blob);
    const sanitizedUrl = sanitizeHtml(url);
    const audioRecording = {
      name: fileName,
      type: 2,
      nativeURL: sanitizedUrl,
      size: utilService.formatBytes(fileData.size),
    };
    setParams(fileData, audioRecording);
  };

  const nativeStartRecord = async () => {
    let options: CaptureAudioOptions = { limit: 1, duration: 30 };
    let capture: any = await MediaCapture.captureAudio(options);
    if (capture.length > 0) {
      const replacingComma = capture[0].fullPath.split("%2C").join(",");
      const replacingSpace = replacingComma.split("%20").join(" ");
      copyFileToLocalDir(replacingSpace);
    }
    console.log((capture[0] as MediaFile).fullPath);
  };

  const copyFileToLocalDir = async (fullPath: any) => {
    const name = fullPath.substr(fullPath.lastIndexOf("/") + 1);
    let resolvedPath: any;
    let path = fullPath.substring(0, fullPath.lastIndexOf("/"));
    if (Capacitor.getPlatform() === "ios") {
      resolvedPath = await ionicFile.resolveDirectoryUrl("file://" + path);
    } else {
      resolvedPath = await ionicFile.resolveDirectoryUrl(path);
    }
    readAsArrayBuffer(resolvedPath, name);
  };

  const readAsArrayBuffer = (resolvedPath: any, name: any) => {
    return ionicFile.readAsArrayBuffer(resolvedPath.nativeURL, name).then(
      (buffer: any) => {
        const fileExtension = name.match(/\.[A-z0-9]+$/i)[0].slice(1);
        // get the buffer and make a blob to be saved
        let blob = new Blob([buffer], {
          type: `audio/${fileExtension}`,
        });
        setFileData(blob, resolvedPath.nativeURL, name, fileExtension);
      },
      (error: any) => console.log(error)
    );
  };

  const setFileData = (Blob: any, path: any, name: any, extn: any) => {
    const fileData = blobToFile(Blob, name);
    const filePath = path + name;
    setNativeParams(fileData, filePath, extn);
  };

  const blobToFile = (theBlob: any, fileName: string): any => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;
    // b.__proto__ = File.prototype;

    //Cast to a File() type
    return theBlob as any;
  };

  const mapToGuidData = () => {
    if (props.isStatusBoard) {
      var initialArray = [];
      initialArray.push(utilService.getLoggedUserGuid());
      return JSON.stringify(initialArray);
    } else {
      return JSON.stringify(
        doctorsListService.getSelectedUsersList(props.selectedDoctorData)
      );
    }
  };

  const setParams = (fileData: any, audioRecording: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    audioRecording.clientMediaID = clientMediaID;
    // this.audioRecordingList.size = this.fileSize;
    const params = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 2,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name:
        "AUD-" +
        new Date().getDate() +
        new Date().getMonth() +
        new Date().getHours() +
        new Date().getMinutes() +
        new Date().getSeconds() +
        ".mp3",
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    EMSAudioService.displayAudioList.push(audioRecording);
    EMSAudioService.uploadAudioList.push(params);
    props.onCompleteMedia();
  };

  const setNativeParams = (fileData: any, filePath: any, extn: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const filename =
      "AUD-" +
      new Date().getDate() +
      new Date().getMonth() +
      new Date().getHours() +
      new Date().getMinutes() +
      new Date().getSeconds() +
      "." +
      extn;
    // ".mp3";
    const serverParams = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 2,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      // name: filePath.substr(filePath.lastIndexOf("/") + 1),
      name: filename,
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    const localParams = {
      clientMediaID: clientMediaID,
      type: 2,
      // name: filePath.substr(filePath.lastIndexOf("/") + 1),
      name: filename,
      nativeURL: filePath,
      size: utilService.formatBytes(fileData.size),
    };
    EMSAudioService.displayAudioList.push(localParams);
    EMSAudioService.uploadAudioList.push(serverParams);
    props.onCompleteMedia();
  };

  return <div></div>;
};

export default EMSAudioComponent;
